import { DateTime } from 'luxon';
import { useMemo } from 'react';

import { BillProjectHoursRequestFilter } from '@work4all/models/lib/Classes/BillProjectHoursRequestFilter.entity';
import { BillProjectHoursRequestSettings } from '@work4all/models/lib/Classes/BillProjectHoursRequestSettings.entity';
import { BzObjType } from '@work4all/models/lib/Enums/BzObjType.enum';
import { ProjectHoursBillingBy } from '@work4all/models/lib/Enums/ProjectHoursBillingBy.enum';
import { ProjectHoursBillingType } from '@work4all/models/lib/Enums/ProjectHoursBillingType.enum';

import { ProjectHourBillingOverlayFormValue } from './types';

type Props = {
  id: number;
  projectTimeIds: number[];
  startDate?: string;
  endDate?: string;
  bzObjType: BzObjType;
};

export const useProjectHourBillingOverlayDefaultValues = ({
  id,
  projectTimeIds,
  startDate,
  endDate,
  bzObjType,
}: Props): ProjectHourBillingOverlayFormValue => {
  return useMemo(() => {
    const todayDateFormatted = DateTime.now().toFormat('yyyy-MM-dd');

    const mode = projectTimeIds?.length > 0 ? 'projectTimes' : 'project';

    const filters: BillProjectHoursRequestFilter = {
      projectCode: id,
      onlyNotBilled: true,
      fromDate:
        startDate || DateTime.now().startOf('month').toFormat('yyyy-MM-dd'),
      toDate: endDate || todayDateFormatted,
      projectTimeCodes: projectTimeIds,
      onlyCompletedTickets: false,
    };

    const settings: BillProjectHoursRequestSettings = {
      documentDate: todayDateFormatted,
      billingBy: ProjectHoursBillingBy.CUSTOMER,
      billingType: ProjectHoursBillingType.LIST_ALL_SERVICES,
      bzObjType: bzObjType,
      converAllPositionsFromOrderConformation: false,
      headerShowOrderReference: true,
      headerShowProjectReference: true,
      headerShowTimespan: true,
      positionShowOrderReference: true,
      customerCodes: [],
      orderConfirmationCodes: [],
      positionAddArticleDescription: true,
      positionAddComment: true,
      positionAddDate: true,
      positionAddUser: true,
    };

    return {
      filters,
      settings,
      mode,
      previewIndex: 1,
    };
  }, [id, projectTimeIds, startDate, endDate, bzObjType]);
};
